import { Component, OnInit } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';

import { JobSearchService } from '../../../../../../../UI/src/app/shared/job-search/job-search.service';
import { FacetContainer } from '../../../../../../../UI/src/app/shared/job-search/job-results.dto';
import * as _ from 'lodash';

@Component({
  selector: 'sts-modal-job-location',
  templateUrl: 'job-location-modal.component.html'
})
export class JobSearchLocationComponent implements OnInit {

  public locationFacets;
  public locationList;
  public locationSearchKey = '';

  constructor(
    public jobsSearchService: JobSearchService,
    public viewCtrl: ViewController,
    public params: NavParams
  ) { }

  ngOnInit() {
    this.jobsSearchService.fetchLocations().then(
      (res) => {
      var list = this.jobsSearchService.getNotSelectedLocations(res);
      this.locationFacets = list;
      this.locationList = list;
      }
    );
  }

  dismiss(data) {
    this.viewCtrl.dismiss(data);
  }

  onFacetChanged() {
    if (!this.locationSearchKey) {
      return;
    }
    const locationSearchValue = (this.locationSearchKey === '') ? '*' : this.locationSearchKey;
    this.locationFacets = _.filter(this.locationList, function (item) {
    return !item.isApplied && item.value.toLowerCase().indexOf(locationSearchValue.toLowerCase()) > -1
  });
  }

  locationSelected(loc) {
    this.locationSearchKey = loc.value;
    loc.isApplied = true;
    loc.filterQuery = {
      name: loc.key,
      searchFieldName: loc.customField1,
      value: loc.key,
      uncodedValue: loc.customField2
    };
    this.jobsSearchService.fillInLocationFilter(loc);
    this.dismiss(loc);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/job-search/components/job-location-modal/job-location-modal.component.ts